module.exports = __webpack_public_path__ + "static/media/soundexchange-icon.34bbac99.svg";